// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"064a1539","207":"6a28a9b0","266":"66f6e780","635":"1010e4b0","738":"94f5a01e","867":"38686ae9"}[chunkId] + ".chunk.css";
};